import SupplierEditForm from "./supplier-edit-form";

export default SupplierEditForm;